module.exports = __webpack_public_path__ + "static/c3-f9d9fa293d9d51cbe3583e732ca011be.png";